/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignUpWithGoogleContainer_auth = {
    readonly integrations: {
        readonly google: {
            readonly redirectURL: string;
        };
    };
    readonly " $refType": "SignUpWithGoogleContainer_auth";
};
export type SignUpWithGoogleContainer_auth$data = SignUpWithGoogleContainer_auth;
export type SignUpWithGoogleContainer_auth$key = {
    readonly " $data"?: SignUpWithGoogleContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"SignUpWithGoogleContainer_auth">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpWithGoogleContainer_auth",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoogleAuthIntegration",
                    "kind": "LinkedField",
                    "name": "google",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "redirectURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any);
(node as any).hash = '8651a000bce12f87f8bdae9ba103954c';
export default node;
